import _         from 'lodash'
import pluralize from 'pluralize'
import Immutable from 'immutable'

import Repository      from './repository'
import RelationBuilder from './relation_builder'

import { BelongsTo, HasMany, HasManyThrough, AssociationCollection } from './associations'

export default class RepositoryBuilder
  constructor: ->
    @relations    = new Immutable.Map
    @associations = new AssociationCollection

  for: (baseUrl, auth) ->
    repository = new Repository(baseUrl, auth, @)

    @relations.forEach (relation) ->
      Object.defineProperty(repository, relation.name, get: -> relation.for(@))

    repository

  forBackend: (backend) ->
    @for(backend.baseUrl, backend.auth)

  registerRelation: (model, route = null, name = null) ->
    name      ?= _.lowerFirst(pluralize(model.name))
    builder    = new RelationBuilder(name, model, route)
    @relations = @relations.set(name, builder)

  registerHasMany: (hasManyModel, belongsToModel, name = null, foreignKey = null, backendName = null) ->
    name        ?= _.lowerFirst(pluralize(belongsToModel.name))
    foreignKey  ?= _.lowerFirst(hasManyModel.name) + 'ID'
    backendName ?= _.snakeCase(name)

    hasMany = new HasMany(name, backendName, hasManyModel, belongsToModel, foreignKey)

    @associations = @associations.add(hasMany)

  registerBelongsTo: (belongsToModel, hasManyModel, name = null,
                       foreignKey = null, backendName = null) ->
    name        ?= _.lowerFirst(hasManyModel.name)
    backendName ?= _.snakeCase(name)
    foreignKey  ?= name + 'ID'

    belongsTo = new BelongsTo(name, backendName, belongsToModel, hasManyModel, foreignKey)

    @associations = @associations.add(belongsTo)

  registerHasManyThrough: (sourceModel, name, associationNames) ->
    if associationNames.length < 2
      throw new Error('HasManyThrough association needs at least two association names')

    @associations = @associations.add(new HasManyThrough(name, sourceModel, associationNames))

  # TODO: add registerHasOne
  # TODO: add registerHasOneThrough

  registerAllFrom: (repository) ->
    @registerRelationsFrom(repository)
    @registerAssociationsFrom(repository)

  registerRelationsFrom: (repository) ->
    @relations = repository.relations.merge(@relations)

  registerAssociationsFrom: (repository) ->
    @associations = repository.associations.merge(@associations)
